import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { TariffCard } from "@/features/billing/TariffCard";
import { getTariff, tariffKeys } from "@/features/billing/tariffs.api";
import { firstAllowedRoute } from "@/lib/auth";
import { mayReadTariffs } from "@/features/billing/access";

// Commercie → Tarieven → one tariff: its periods and tables, and who uses it (docs/tms-facturatie.md §24).
export const Route = createFileRoute("/_shell/billing/tariffs/$id")({
  beforeLoad: ({ context }) => {
    if (!mayReadTariffs(context.session)) throw redirect({ to: firstAllowedRoute(context.session) });
  },
  component: TariffScreen,
});

function TariffScreen() {
  const { t } = useTranslation();
  const { id } = Route.useParams();
  const query = useQuery({ queryKey: tariffKeys.detail(id), queryFn: () => getTariff(id), retry: false });
  return (
    <div className="wl-page" data-screen-label="Back-office Tariff">
      {query.error ? (
        <div className="wl-alert wl-alert--danger" role="alert">
          {query.error instanceof Error ? query.error.message : String(query.error)}
        </div>
      ) : query.data ? (
        <TariffCard data={query.data} />
      ) : (
        <span className="t-caption t-muted">{t("common.loading")}</span>
      )}
    </div>
  );
}
